<template>
  <h2 class="form-title">Добавление лота</h2>
  <form class="form" @submit.prevent="handleSubmit">
    <div class="form-group">
      <label>ID товара:</label>
      <input class="form-item" v-model="form.id" type="text" required />
    </div>

    <div class="form-group">
      <label>Название:</label>
      <input class="form-item" v-model="form.name" type="text" required />
    </div>

    <div class="form-group">
      <label>Количество для отображения</label>
      <div class="size-options form-item">
        <label v-for="size in availableSizes" :key="size" class="size-option">
          <input type="checkbox" :value="size" v-model="form.size" />
          {{ size }}
        </label>
      </div>
    </div>

    <div class="form-group checkbox form-item">
      <label>
        <input v-model="form.fetch" type="checkbox" />
        Fetch
      </label>
    </div>

    <div class="form-group checkbox form-item">
      <label>
        <input v-model="form.active" type="checkbox" />
        Active
      </label>
    </div>

    <button type="submit">Добавить лот</button>
    <p v-if="error" class="error">{{ error }}</p>
    <p v-if="success" class="success">{{ success }}</p>
  </form>
</template>

<script setup>
import { ref } from 'vue'
import axios from 'axios'
import { api } from '@/api/http'

const availableSizes = [1, 10, 25, 100]

const form = ref({
  id: '',
  name: '',
  maximum: 0,
  size: [],
  fetch: false,
  active: false
})

const error = ref('')
const success = ref('')

const handleSubmit = async () => {
  error.value = ''
  success.value = ''

  if (form.value.size.length === 0) {
    error.value = 'Выберите хотя бы один размер'
    return
  }

  try {
    await api.post('/lots', {
      ...form.value,
      size: [...form.value.size].sort((a, b) => a - b)
    })

    success.value = 'Лот успешно добавлен!'

    form.value = {
      id: '',
      name: '',
      maximum: 0,
      size: [],
      fetch: false,
      active: false
    }
  } catch (err) {
    if (axios.isAxiosError(err)) {
      error.value = err.response?.data?.message || 'Ошибка при создании лота'
    } else {
      error.value = 'Ошибка при создании лота'
    }
  }
}
</script>

<style scoped>
.form {
  display: flex;
  gap: 25px;
  align-items: center;
  margin-bottom: 30px;
}

.form-item {
  height: 30px;
}

.form-title {
  margin-bottom: 20px;
}

label {
  display: block;
  margin-bottom: 5px;
  font-weight: bold;
}

input[type='text'],
input[type='number'] {
  width: 100%;
  padding: 8px;
  box-sizing: border-box;
}

.size-options {
  display: flex;
  gap: 15px;
  margin-top: 5px;
}

.size-option {
  display: flex;
  align-items: center;
  gap: 5px;
  font-weight: normal;
}

.checkbox {
  display: flex;
  align-items: center;
}

.checkbox label {
  display: flex;
  align-items: center;
  gap: 5px;
  font-weight: normal;
}

button {
  padding: 10px 15px;
  background-color: #42b983;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}

button:hover {
  background-color: #3aa876;
}

.error {
  color: red;
  margin-top: 10px;
}

.success {
  color: green;
  margin-top: 10px;
}
</style>
